// @ts-ignore — ESM-only package, CRA's TS module resolution can't resolve subpath exports
import { createInternalNeonAuth } from '@neondatabase/auth';

const neonAuth = createInternalNeonAuth(process.env.REACT_APP_NEON_AUTH_URL!);

export const authClient = neonAuth.adapter;
export const getJWTToken = (): Promise<string | null> => neonAuth.getJWTToken();
